import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		card: {
			overflow: "unset",
		},
		cardContent: {
			padding: 24,
			"& * > :first-child > h3": {
				marginTop: 0
			} 
		}
	} satisfies Record<string, CSSObject>)
}
